import { SnackbarProvider as SnackbarProviderUnwrapped } from 'notistack';
import { ReactNode } from 'react';

import { AlertSnackbar } from './AlertSnackbar';

interface SnackbarProviderProps {
  children: ReactNode;
}

const SnackbarProvider = ({ children }: SnackbarProviderProps) => (
  <SnackbarProviderUnwrapped
    Components={{
      success: AlertSnackbar,
      error: AlertSnackbar,
      info: AlertSnackbar,
      warning: AlertSnackbar,
    }}
  >
    {children}
  </SnackbarProviderUnwrapped>
);

export { SnackbarProvider };
